// tslint:disable:no-trailing-whitespace
// tslint:disable:member-ordering
import { BaseEntity } from '../base-entity';
import { Family } from './family';
import { PhotoLink } from './photo-link';

/// <code-import> Place custom imports between <code-import> tags

/// </code-import>

/// <module-code> Place module level code between <module-code> tags

/// </module-code>

export class Photo extends BaseEntity  {

  /// <code> Place custom code between <code> tags
  
  /// </code>

  // Generated code. Do not place code below this line.
  id!: number;
  approved?: Date;
  caption?: string;
  familyId?: number;
  fileName?: string;
  isDirectoryPhoto!: boolean;
  family!: Family;
  links!: PhotoLink[];
}

